// extracted by mini-css-extract-plugin
export default {"menuBlock":"eI-z","title":"fI-z","nav":"gI-z","flexCell":"hI-z","facetLink":"iI-z"};